module.exports = __webpack_public_path__ + "media/images/img_class02-c437ca1949f860d21eb5fb80d5e18c9a.jpg";